class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.coverImage = this.querySelector('.video-cover');
    this.playButton = this.querySelector('.play-button');
    this.isPlaying = false;
    
    this.init();
  }

  init() {
    if (this.playButton) {
      this.playButton.addEventListener('click', () => this.togglePlay());
    }

    this.video.addEventListener('play', () => {
      this.isPlaying = true;
      this.classList.add('is-playing');
    });

    this.video.addEventListener('pause', () => {
      this.isPlaying = false;
      this.classList.remove('is-playing');
    });
  }

  togglePlay() {
    if (this.isPlaying) {
      this.video.pause();
    } else {
      this.video.play();
    }
  }
}

customElements.define('video-player', VideoPlayer);
